import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContentHistoryProps } from './ContentHistory.tsx';

export const ContentHistoryLoader: LoadableType<ContentHistoryProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentHistory" */ './ContentHistory.tsx'))
			.ContentHistory,
});
